import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

class WalletList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selectedWallet: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    services
      .getMappedWallets()
      .then((response) => {
        const tmp = response.data.data;
        const options = tmp.map((bank) => ({
          value: bank.bunk_wallet_uuid,
          label: `${bank.wallet.bank_name}(${bank.settlement_bank.settlement_bank_name})`,
        }));
        this.setState({ options });
        if (options.length > 0) {
          this.handleChange(options[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChange(selectedOption) {
    this.setState({ selectedWallet: selectedOption });
    this.props.handleBankChange(selectedOption);
  }

  handleReset() {
    const { options } = this.state;
    if (options.length > 0) {
      this.handleChange(options[0]);
    }
  }

  render() {
    const { options, selectedWallet } = this.state;

    return (
      <Select
        onChange={this.handleChange}
        isClearable={false}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="payment_mode"
        placeholder="Select Wallet"
        value={selectedWallet}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { WalletList };
